import { module } from 'angular';
import templateBuilderTabsDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/tabs/display.html', templateBuilderTabsDisplay);
});
